class LensGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.dragging = false
    this.rect = null
  }

  setupListeners () {
    super.setupListeners()

    this.els.dragger.element.addEventListener(
      'pointerdown',
      this.startDrag.bind(this),
    )

    window.addEventListener('pointermove', this.onMove.bind(this))
    window.addEventListener('pointerup', this.stopDrag.bind(this))

    this.addEventListener('pointerdown', (event) => {
      const clickedDraggerEl = event.target.closest(
        this.els?.dragger?.selector,
      )
      const clickedMediaEl = event.target.closest(this.els?.media?.selector)
      const clickedThumbsEl = event.target.closest(this.els?.thumbs?.selector)

      if (!clickedDraggerEl && !clickedThumbsEl && clickedMediaEl) {
        this.updateFromClientX(event.clientX)
      }
    })

    this.els.dragger.element.addEventListener(
      'keydown',
      this.onKeyDown.bind(this),
    )

    this.handleThumbSwitch = this.handleThumbSwitch.bind(this)
    this.listeners.add(this, 'click', this.handleThumbSwitch)

    this.handleCategorySwitch = this.handleCategorySwitch.bind(this)
    this.listeners.add(this, 'click', this.handleCategorySwitch)

    this.handleColorwaySwitch = this.handleColorwaySwitch.bind(this)
    this.listeners.add(this, 'click', this.handleColorwaySwitch)
  }

  startDrag (event) {
    event.preventDefault()

    this.dragging = true
    this.rect = this.els.media.element.getBoundingClientRect()

    this.updateFromClientX(event.clientX)
  }

  stopDrag () {
    this.dragging = false
    this.rect = null
  }

  onMove (event) {
    if (!this.dragging) return
    this.updateFromClientX(event.clientX)
  }

  updateFromClientX (x) {
    if (!this.rect) this.rect = this.els.media.element.getBoundingClientRect()

    const position = 100 - ((x - this.rect.left) / this.rect.width) * 100

    this.setPosition(position)
  }

  onKeyDown (e) {
    const step = e.shiftKey ? 10 : 5
    const current = this.getCurrentValue()

    let newVal = null

    switch (e.key) {
      case 'ArrowLeft':
        newVal = current - step
        break
      case 'ArrowRight':
        newVal = current + step
        break
      case 'Home':
        newVal = 0
        break
      case 'End':
        newVal = 100
        break
      case 'PageDown':
        newVal = current - 10
        break
      case 'PageUp':
        newVal = current + 10
        break
    }

    if (newVal !== null) {
      e.preventDefault()
      this.setPosition(newVal)
    }
  }

  getCurrentValue () {
    const revealPosition = getComputedStyle(this)
      .getPropertyValue('--Reveal_Position')
      .trim()

    return parseFloat(revealPosition)
  }

  setPosition (position) {
    const clamped = Math.max(0, Math.min(100, position))

    this.style.setProperty('--Reveal_Position', `${clamped}%`)
  }

  handleCategorySwitch (event) {
    const categoryTriggerEl = event.target.closest(
      this.els?.category?.selector,
    )

    if (!categoryTriggerEl) return

    this.els.category.elements.forEach((categoryEl) => {
      categoryEl.setAttribute(
        'aria-selected',
        categoryEl === categoryTriggerEl,
      )
    })

    const selectedCategory = (categoryTriggerEl.dataset.category || '')
      .toString()
      .trim()
      .toLowerCase()

    this.els.colorway.elements.forEach((colorwayEl) => {
      const rawCats = (colorwayEl.dataset.category || '').toString()
      const lensCategories = rawCats
        .split(',')
        .map((c) => c.trim().toLowerCase())
        .filter(Boolean)

      const isVisible =
        selectedCategory === 'all' ||
        selectedCategory === '' ||
        lensCategories.includes(selectedCategory)

      colorwayEl.setAttribute('aria-hidden', (!isVisible).toString())
    })

    if (categoryTriggerEl.dataset.category === 'all') return

    this.els.thumb.elements.forEach((thumbEl) => {
      thumbEl.setAttribute(
        'aria-selected',
        thumbEl.dataset.index === categoryTriggerEl.dataset.category,
      )
    })

    this.els.image.elements.forEach((imageEl) => {
      imageEl.setAttribute(
        'aria-hidden',
        imageEl.dataset.index !== categoryTriggerEl.dataset.category,
      )
    })
  }

  handleThumbSwitch (event) {
    const thumbTriggerEl = event.target.closest(this.els?.thumb?.selector)

    if (!thumbTriggerEl) return

    this.els.thumb.elements.forEach((thumbEl) => {
      thumbEl.setAttribute('aria-selected', thumbEl === thumbTriggerEl)
    })

    this.els.image.elements.forEach((imageEl) => {
      imageEl.setAttribute(
        'aria-hidden',
        imageEl.dataset.index !== thumbTriggerEl.dataset.index,
      )
    })
  }

  handleColorwaySwitch (event) {
    const colorwayTriggerEl = event.target.closest(
      this.els?.colorway?.selector,
    )

    if (!colorwayTriggerEl) return

    this.els.colorway.elements.forEach((colorwayEl) => {
      colorwayEl.setAttribute(
        'aria-selected',
        colorwayEl === colorwayTriggerEl,
      )
    })

    this.els['colorway-title'].elements.forEach((colorwayTitleEl) => {
      colorwayTitleEl.innerText = colorwayTriggerEl.dataset.colorwayTitle
    })

    this.els['colorway-media'].elements.forEach((colorwayMediaEl) => {
      colorwayMediaEl.setAttribute(
        'aria-hidden',
        colorwayMediaEl.dataset.colorway !== colorwayTriggerEl.dataset.colorway,
      )
    })

    this.els['vlt-title'].element.innerText =
      colorwayTriggerEl.dataset.vltTitle
    this.els.vlt.elements.forEach((vltEl) => {
      vltEl.setAttribute(
        'aria-hidden',
        vltEl.dataset.colorway !== colorwayTriggerEl.dataset.colorway,
      )
    })

    if (this?.els?.button?.exists) {
      this.els.button.element.href = colorwayTriggerEl.dataset.link
    }
  }
}

if (!customElements.get('lens-guide')) {
  customElements.define('lens-guide', LensGuide)
}
